/* eslint-disable max-len */
// Dependencies
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'

// Component
import {Icon} from '@lazarusai/forms-ui-components'

// Images
// import LazarusLogo from '../images/LazarusLogo.svg'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesManageTools from '../styles/ManageTools.module.css'
import stylesManageFiles from '../styles/ManageFiles.module.css'
import stylesPillButton from '../styles/PillButton.module.css'
import Helpers from '../Helpers'

function ManageTools(props) {
  const [isToolNavShowing, setIsToolNavShowing] = useState(false)
  const [isToolBroken, setIsToolBroken] = useState(false)

  useEffect(() => {
    if (props.tools) {
      setIsToolBroken((Object.keys(props.tools).some((toolName) => {
        return props.tools?.[toolName]?.status?.toLowerCase() === 'error'
      }) && props.isCodeBreakUser))
    }
  }, [props.tools])

  return (
    <>
      <div
        className={`${stylesPillButton['pill-button']} ${
          (isToolNavShowing && !isToolBroken) ? stylesPillButton['pill-button-selected']: ''
        } ${
          isToolBroken ? stylesPillButton['pill-button-error']: ''
        }`}
        onClick={() => {
          setIsToolNavShowing(!isToolNavShowing)
        }}
      >
        <Icon
          icon={'layers-outline'}
        />
        Manage tools
      </div>
      {isToolNavShowing &&
        <div
          className={`${stylesManageFiles['manage-files-modal']}`}
        >
          <div
            className={`${stylesManageTools['tools-modal']}`}
          >
            <div
              className={stylesManageFiles['file-directory-title']}
            >
              <div
                className={stylesManageFiles['file-directory-title-text']}
              >
                Tools
              </div>
              <div
                className={stylesManageFiles['file-directory-title-close']}
              >
                <Icon
                  icon='close-outline'
                  onClick={() => {
                    setIsToolNavShowing(false)
                  }}
                />
              </div>
            </div>
            <div
              className={stylesManageTools['tools-modal-body']}
            >
              {Object.keys(props.tools).map((toolName, tIndex) => {
                const toolPrettyName = Helpers.snakeCaseToDisplay(toolName)
                const toolDescription = props.tools?.[toolName]?.description
                const isToolError = props.isCodeBreakUser && props.tools?.[toolName]?.status?.toLowerCase() === 'error'
                return (
                  <div
                    className={`${stylesManageTools['tools-row']} ${isToolError ? stylesManageTools['tools-row-error']: ''}`}
                    key={`${tIndex}-${toolName}`}
                  >
                    <div
                      className={stylesManageTools['tools-row-tool']}
                      key={`${tIndex}-${toolName}`}
                    >
                      {toolPrettyName}{isToolError ? ' - Error': ''}
                    </div>
                    <div
                      className={stylesManageTools['tools-row-description']}
                      key={`${tIndex}-${toolName}`}
                    >
                      {toolDescription}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      }
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  tools: state.userReducer.tools,
  isCodeBreakUser: state.userReducer.isCodeBreakUser,
})

export default connect(
    mapStateToProps,
    {},
)(ManageTools)
